import { UIText2 } from '@cian/ui-kit';
import cx from 'clsx';

import * as styles from './OfferCard.css';

interface IOfferCardProps {
  isHidden: boolean;
  isAnimateHide: boolean;
  price: React.ReactNode;
  title: React.ReactNode;
  address?: React.ReactNode;
  mouseOver: () => void;
  mouseOut: () => void;
  onClick: () => void;
  carousel: React.ReactNode;
  geoInformation?: React.ReactNode;
  phone: React.ReactNode;
  agent?: React.ReactNode;
  area?: React.ReactNode;
  type?: React.ReactNode;
  controls?: React.ReactNode;
  note?: React.ReactNode;
  vas?: React.ReactNode;
  date?: React.ReactNode;
  description?: string;
  href: string;
}

export const OfferCard = ({
  isHidden,
  isAnimateHide,
  type,
  area,
  title,
  carousel,
  address,
  geoInformation,
  price,
  phone,
  agent,
  description,
  controls,
  note,
  vas,
  date,
  href,
  mouseOver,
  mouseOut,
  onClick,
}: IOfferCardProps) => {
  return (
    <div
      className={cx(
        styles['container'],
        isAnimateHide && styles['container--hide'],
        isHidden && styles['container--hidden'],
      )}
      onMouseOver={mouseOver}
      onMouseLeave={mouseOut}
    >
      <div className={cx(styles['column'], styles['column_carousel'])} data-name="OfferCardGallery">
        {carousel}
      </div>
      <div className={cx(styles['column'], styles['main_info'])}>
        <div className={styles['geo_info']}>
          {title}
          {area}
          {geoInformation}
          {address}
        </div>
        <div className={styles['price_info']}>{price}</div>
        <div className={styles['type_info']}>{type}</div>
        {description ? (
          <div className={styles['description']} data-name="OfferCardDescription">
            <a href={href} onClick={onClick} className={styles['link']} target="_blank" rel="noreferrer">
              <div className={styles['description_content']}>
                <UIText2>{description}</UIText2>
              </div>
            </a>
          </div>
        ) : null}
        <div className={styles['note']}>{note}</div>
      </div>
      <div className={cx(styles['column'], styles['side_info'])}>
        <div className={styles['block']}>
          {phone}
          {agent}
        </div>
        <div className={styles['block']}>
          {vas}
          {date}
        </div>
      </div>
      <div className={styles['column']}>{controls}</div>
    </div>
  );
};
